import React, { FC, ReactNode } from 'react'

import { DecorationTitle, Txt } from 'src/components/atoms'
import { ProjectInsightDetailItem } from 'src/components/molecules'

import { ProjectDetailEntity } from 'src/types'

function ProjectInsightDetailContainer({ children }: { children: ReactNode }) {
  return <div className="tw-w-1/4 tw-max-w-[13.14rem]">{children}</div>
}
function Divider() {
  return <div className="tw-bg-border-primary tw-h-[1.7rem] tw-w-[1px]" />
}

type Props = {
  project: ProjectDetailEntity
  className?: string
}

export const ProjectInsightDetail: FC<Props> = ({ project, className }) => {
  return (
    <div className={className}>
      <div className="tw-full-justify">
        <DecorationTitle>インサイト</DecorationTitle>
        <Txt sizeType="s" className="tw-text-standardText-secondary">
          ※削除済お客様情報の統計値も含む。
        </Txt>
      </div>
      <div className="tw-mt-s2 tw-flex tw-gap-s2 tw-items-center">
        <ProjectInsightDetailContainer>
          <ProjectInsightDetailItem
            title="お客様登録"
            count={project.purchaserCount}
            tooltipContent={
              <Txt sizeType="s">
                プレゼンツールやマーケティング支援
                <br />
                から流入されたお客様の登録合計数
              </Txt>
            }
          />
        </ProjectInsightDetailContainer>
        <Divider />
        <ProjectInsightDetailContainer>
          <ProjectInsightDetailItem
            title="申込・成約数"
            count={project.applicationCount}
            tooltipContent={<Txt sizeType="s">申込済または成約済のお客様の合計数</Txt>}
          />
        </ProjectInsightDetailContainer>
        <Divider />
        <ProjectInsightDetailContainer>
          <ProjectInsightDetailItem
            title="累計閲覧ページ数"
            count={project.totalPvCount}
            tooltipContent={<Txt sizeType="s">すべてのお客様閲覧ページの合計数</Txt>}
          />
        </ProjectInsightDetailContainer>
        <Divider />
        <ProjectInsightDetailContainer>
          <ProjectInsightDetailItem
            title="累計アクセス数"
            count={project.totalSessionCount}
            tooltipContent={
              <Txt sizeType="s">
                すべてのお客様がサイトに訪問した合計数
                <br />
                <span className="tw-text-standardText-secondary">
                  ※お客様が30分以上操作を行わない場合、以降
                  <br />
                  の操作は新しい訪問として扱われます。
                </span>
              </Txt>
            }
          />
        </ProjectInsightDetailContainer>
      </div>
    </div>
  )
}
